import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63499652"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "top-box" }
const _hoisted_3 = { class: "invite-code" }
const _hoisted_4 = { class: "box" }
const _hoisted_5 = { class: "info-box" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = { class: "info-msg" }
const _hoisted_8 = { class: "info-num" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-divider" }, null, -1 /* HOISTED */))
const _hoisted_10 = { class: "info-item" }
const _hoisted_11 = {
  class: "info-msg",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "info-num" }
const _hoisted_14 = { class: "duihuan-div" }
const _hoisted_15 = { style: {"color":"black"} }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "share-btn" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "tab-con" }
const _hoisted_23 = { style: {"text-align":"right"} }
const _hoisted_24 = { class: "tab-con" }
const _hoisted_25 = { style: {"text-align":"center"} }
const _hoisted_26 = { style: {"text-align":"right"} }
const _hoisted_27 = { class: "sheet-class" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sheet-title" }, "兑换奖品", -1 /* HOISTED */))
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "reward-list-class" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.showTopBar)
      ? (_openBlock(), _createBlock(_component_van_nav_bar, {
          key: 0,
          title: $setup.t('me.yqhy'),
          "left-arrow": "",
          fixed: "",
          "z-index": "99",
          placeholder: "",
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
        }, null, 8 /* PROPS */, ["title"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('me.invitecode') + "：" + $setup.my_fid), 1 /* TEXT */),
        _createElementVNode("div", {
          class: "copy-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onCopyClick('copy-btn', $setup.my_fid)))
        }, _toDisplayString(_ctx.$t('复制')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", {
        class: "bg",
        style: _normalizeStyle($setup.activityBgStyle)
      }, null, 4 /* STYLE */),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_image, {
          round: "",
          width: "70",
          height: "70",
          class: "avatar",
          src: $setup.user.avatar
        }, null, 8 /* PROPS */, ["src"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('邀请的人数')), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_8, _toDisplayString($setup.invite_count), 1 /* TEXT */),
            _createVNode(_component_van_button, {
              style: {"padding":"5px 0px","width":"125px"},
              onClick: $setup.showRecordDialog,
              round: "",
              plain: "",
              color: "#C29030"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('查看记录')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, [
              _createTextVNode(_toDisplayString(_ctx.$t('可兑换积分')), 1 /* TEXT */),
              _createElementVNode("img", {
                class: "wenhao",
                src: $setup.wenhao_img
              }, null, 8 /* PROPS */, _hoisted_12)
            ]),
            _createElementVNode("span", _hoisted_13, _toDisplayString($setup.score), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_van_button, {
                style: {"padding":"5px 0px","width":"153px","height":"30px","font-size":"12px"},
                disabled: $setup.score < 1,
                onClick: $setup.showAllExchangeSheet,
                round: "",
                color: "linear-gradient(to bottom, #F6DF87, #EAC261)"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('兑换奖品')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled"])
            ])
          ])
        ]),
        _createElementVNode("img", {
          class: "desc-title",
          src: $setup.desc_title_img
        }, null, 8 /* PROPS */, _hoisted_16),
        _createElementVNode("div", {
          innerHTML: $setup.rule_html,
          class: "v-htmlclass"
        }, null, 8 /* PROPS */, _hoisted_17)
      ]),
      _createElementVNode("div", {
        class: "bottom-box",
        onClick: $setup.onShareClick
      }, [
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('立即邀请')), 1 /* TEXT */)
      ]),
      _createCommentVNode(" 兑换记录+邀请记录弹框 "),
      _createVNode(_component_van_overlay, {
        "class-name": "dialog",
        show: $setup.showRecord,
        "lock-scroll": false,
        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showRecord = false))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "content",
            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('记录')), 1 /* TEXT */),
              _createElementVNode("img", {
                src: $setup.close_img,
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showRecord = false))
              }, null, 8 /* PROPS */, _hoisted_21)
            ]),
            _createVNode(_component_van_tabs, {
              active: $setup.recordActive,
              "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => (($setup.recordActive) = $event)),
              background: "#00000000",
              color: "#fff",
              "title-active-color": "#fff",
              "title-inactive-color": "#ffffffd0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_tab, {
                  title: _ctx.$t('好友记录')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("table", null, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.invite_record, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString((index + 1) + ". " + item.nickname), 1 /* TEXT */),
                              _createElementVNode("td", _hoisted_23, _toDisplayString($setup.formatDate(item.regtime)), 1 /* TEXT */)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createCommentVNode(" <tr v-for=\"(item, index) in invite_record\" :key=\"index\">\n                                        <td>{{ (index + 1) + \". \" + item.nickname }}</td>\n                                        <td style=\"text-align: right;\">{{ formatDate(item.regtime) }}</td>\n                                    </tr>\n                                    <tr v-for=\"(item, index) in invite_record\" :key=\"index\">\n                                        <td>{{ (index + 1) + \". \" + item.nickname }}</td>\n                                        <td style=\"text-align: right;\">{{ formatDate(item.regtime) }}</td>\n                                    </tr>\n                                    <tr v-for=\"(item, index) in invite_record\" :key=\"index\">\n                                        <td>{{ (index + 1) + \". \" + item.nickname }}</td>\n                                        <td style=\"text-align: right;\">{{ formatDate(item.regtime) }}</td>\n                                    </tr>\n                                    <tr v-for=\"(item, index) in invite_record\" :key=\"index\">\n                                        <td>{{ (index + 1) + \". \" + item.nickname }}</td>\n                                        <td style=\"text-align: right;\">{{ formatDate(item.regtime) }}</td>\n                                    </tr> ")
                        ])
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["title"]),
                _createVNode(_component_van_tab, {
                  title: _ctx.$t('兑换记录')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("table", null, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.order_list, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(item.phone), 1 /* TEXT */),
                              _createElementVNode("td", _hoisted_25, _toDisplayString($setup.formatDate(item.addtime).substring(0, 5)), 1 /* TEXT */),
                              _createElementVNode("td", _hoisted_26, _toDisplayString($setup.order_status_map[item.status]), 1 /* TEXT */)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["title"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["active"])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show"]),
      _createVNode(_component_van_action_sheet, {
        show: $setup.showSheetView,
        "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (($setup.showSheetView) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("img", {
              src: $setup.close_black,
              class: "sheet-close",
              onClick: $setup.closeSheetAction
            }, null, 8 /* PROPS */, _hoisted_29),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rewardList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "reward-sub-class",
                  key: index,
                  onClick: ($event: any) => ($setup.showSubmitDialog(index))
                }, [
                  _createElementVNode("img", {
                    src: item.icon
                  }, null, 8 /* PROPS */, _hoisted_32),
                  _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_31))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show"]),
      _createCommentVNode(" 提交兑换，填写电话号码弹框 "),
      _createVNode(_component_van_dialog, {
        show: $setup.showSubmit,
        "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (($setup.showSubmit) = $event)),
        title: _ctx.$t('兑换话费'),
        "show-cancel-button": "",
        lockScroll: "",
        "confirm-button-text": $setup.t('me.ok'),
        "cancel-button-text": $setup.t('tips.cancel'),
        "before-close": $setup.beforeSubmitClose
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, { inset: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: $setup.phone_num,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.phone_num) = $event)),
                error: $setup.input_phone_err,
                "label-align": "center",
                label: "+62",
                placeholder: $setup.t('me.inputphone'),
                class: "custom-field"
              }, null, 8 /* PROPS */, ["modelValue", "error", "placeholder"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show", "title", "confirm-button-text", "cancel-button-text"]),
      _createVNode(_component_van_dialog, {
        show: $setup.showSubmit1,
        "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (($setup.showSubmit1) = $event)),
        title: _ctx.$t('兑换彩金'),
        "show-cancel-button": "",
        lockScroll: "",
        "confirm-button-text": $setup.t('me.ok'),
        "cancel-button-text": $setup.t('tips.cancel'),
        "before-close": $setup.beforeSubmitClose1
      }, null, 8 /* PROPS */, ["show", "title", "confirm-button-text", "cancel-button-text"]),
      _createVNode(_component_van_dialog, {
        show: $setup.showExchangePointAlertView,
        "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (($setup.showExchangePointAlertView) = $event)),
        title: _ctx.$t('兑换积分'),
        "show-cancel-button": "",
        lockScroll: "",
        "confirm-button-text": $setup.t('me.ok'),
        "cancel-button-text": $setup.t('tips.cancel'),
        "before-close": $setup.beforeSubmitClose2
      }, null, 8 /* PROPS */, ["show", "title", "confirm-button-text", "cancel-button-text"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}